import { createStore } from 'vuex';
import vuexPersistedState from 'vuex-persistedstate';

export default createStore({
  state: {
    user: {
      age: null,
      weight: null,
      height: null,
      gender: null,
      ethnicity: null,
      rol: null,
      idusuario:null,
      idioma:null,
    },
    cbc: {
      hb: null,
      plt: null,
      wbc: null,
      mcv: null,
      mch: null,
      neut: null,
      lym: null,
    },
  },
  getters: {
    user: (state) => state.user,
    cbc: (state) => state.cbc
  },
  mutations: {
    setUserData(state, userData) {
      state.user = userData;
    },
/*     setCbcData(state, cbcData) {
      state.cbc = cbcData;
    } */
     setCbcData(state, cbcData) {
    // Actualiza de manera parcial sin sobrescribir todo
    state.cbc = { ...state.cbc, ...cbcData }; // Esta línea es más flexible si solo actualizas algunos valores de CBC
  }
  },
  actions: {
    setUserData({ commit }, userData) {
      commit('setUserData', userData);
    },
    setUserCbc({ commit }, cbcData) {
      commit('setCbcData', cbcData); // Asegúrate de usar el nombre correcto de la mutación
    },
  },
  plugins: [
    vuexPersistedState({
      key: 'userAndCbc', // La clave para el localStorage
      paths: ['user', 'cbc'], // Persistir tanto 'user' como 'cbc'
    }),
  ],
  modules: {
    // Si quieres usar módulos, puedes hacerlo aquí
  }
});
